import { HELP_CENTER_URL, SUPPORT_REQUEST_URL } from "config"
import zozofitAppIcon from "assets/images/zozofit-app-icon.webp"
import {
  BadgeLink,
  BadgesRow,
  BodyText,
  BodyTextWrapper,
  ContentWrapper,
  DownloadCard,
  DownloadCardContent,
  DownloadCardText,
  FooterHighlight,
  FooterLink,
  FooterText,
  GradientOverlay,
  TextSection,
  MainSection,
  PageWrapper,
  Title,
} from "./styled"
import AppStoreDownload from "./AppStoreDownload"
import GooglePlayDownload from "./GooglePlayDownload"
import NotificationIcon from "./NotificationIcon"

const StandaloneShutdownPage = () => {
  return (
    <PageWrapper>
      <GradientOverlay />
      <ContentWrapper>
        <MainSection>
          <NotificationIcon />

          <TextSection>
            <Title>We’ve Moved!</Title>
            <BodyTextWrapper>
              <BodyText>
                We’re moving all Food Journal best features to the ZOZOFIT
                mobile app to give you more powerful and seamless experience.
              </BodyText>
              <BodyText>
                All your data are safely and fully accessible via the mobile
                app. It’s the same Food Journal that you trust, just better and
                much more.
              </BodyText>
            </BodyTextWrapper>
          </TextSection>

          <DownloadCard>
            <DownloadCardContent>
              <img
                src={zozofitAppIcon}
                alt="ZOZOFIT"
                width={56}
                height={56}
                style={{ borderRadius: 12 }}
              />
              <DownloadCardText>
                The ZOZOFIT app is available for both Android and iOS for free.
              </DownloadCardText>
            </DownloadCardContent>
            <BadgesRow>
              <BadgeLink
                href={import.meta.env.VITE_DOWNLOAD_ZOZOFIT_APP_STORE_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                <AppStoreDownload />
              </BadgeLink>
              <BadgeLink
                href={import.meta.env.VITE_DOWNLOAD_ZOZOFIT_GOOGLE_PLAY_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                <GooglePlayDownload />
              </BadgeLink>
            </BadgesRow>
          </DownloadCard>
        </MainSection>

        <FooterText>
          This website will no longer be accessible starting{" "}
          <FooterHighlight>April 30, 2026</FooterHighlight>. We’re here to help
          with the transition. If you run into any trouble, please{" "}
          <FooterLink href={SUPPORT_REQUEST_URL} target="_blank" rel="noopener noreferrer">
            submit a request
          </FooterLink>{" "}
          or visit our{" "}
          <FooterLink href={HELP_CENTER_URL} target="_blank" rel="noopener noreferrer">
            help center
          </FooterLink>
          .
        </FooterText>
      </ContentWrapper>
    </PageWrapper>
  )
}

export default StandaloneShutdownPage
